export const post_user_login = async (formdata : FormData) => {
    try {
        const requestOptions = { method: "POST", body: formdata, redirect: "follow" as RequestRedirect };

        let result = await fetch( process.env.REACT_APP_API_URL + "/bawaslu_phwt/user/login", requestOptions)
            .then((response) => response.json())
            .then((result) => result)
            .catch((error) => { return { status: 500, message: error }; });
        return result;
    } catch (error) {
        return { status: 500, message: error };
    }
}